import React from 'react';
import CompromisoPagoFormModal from '../../../components/ui/GestionMorasComponents/CompromisoPagoFormModal';
import { formatearFecha, formatearMoneda, obtenerFechaActualISO } from '../../../utilities/gestionMorasUtils';

const CompromisoPagoModal = ({
  isOpen,
  prestamo,
  formData,
  errors,
  saving,
  onClose,
  onChange,
  onSubmit
}) => {
  const highlight = prestamo?.ultimo_compromiso_pago ? (
    <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-amber-700">Último compromiso</p>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <p className="text-sm font-semibold text-slate-900">
          {formatearFecha(prestamo.ultimo_compromiso_pago.fecha_compromiso)}
        </p>
        <span className="inline-flex items-center rounded-full bg-white px-3 py-1 text-xs font-semibold text-slate-900">
          {formatearMoneda(prestamo.ultimo_compromiso_pago.monto_compromiso)}
        </span>
      </div>
      <p className="mt-1 text-sm leading-6 text-slate-600">{prestamo.ultimo_compromiso_pago.motivo}</p>
    </div>
  ) : null;

  return (
    <CompromisoPagoFormModal
      isOpen={isOpen}
      dialogId="compromiso-pago-title"
      eyebrow="Gestión de moras"
      title="Registrar compromiso de pago"
      prestamo={prestamo}
      summary={
        <>
          <p className="modal-text mt-2">
            Cliente: <span className="font-semibold text-slate-900">{prestamo?.cliente}</span>
          </p>
          <p className="modal-text">
            Crédito #{prestamo?.numero_credito} | Total a pagar: {formatearMoneda(prestamo?.total_a_pagar)}
          </p>
        </>
      }
      highlight={highlight}
      formData={formData}
      errors={errors}
      saving={saving}
      onClose={onClose}
      onChange={onChange}
      onSubmit={onSubmit}
      minFechaCompromiso={obtenerFechaActualISO()}
      submitLabel="Guardar compromiso"
      savingLabel="Guardando..."
    />
  );
};

export default CompromisoPagoModal;